"use strict";
import { injected } from "wagmi/connectors";
export const TOPAZ_SCW_CONNECTOR_ID = "topaz-id-scw";
export function isTopazScwConnectorId(id) {
  return id === TOPAZ_SCW_CONNECTOR_ID;
}
export function topazScwConnector(provider) {
  return injected({
    target: {
      id: TOPAZ_SCW_CONNECTOR_ID,
      name: "Topaz ID",
      provider
    },
    shimDisconnect: false
  });
}
